import 'waypoints/lib/jquery.waypoints.min.js';

export default {
  init() {
    // JavaScript to be fired on all pages
    $('.js-product-label').click(function () {
      $('.js-product-label').removeClass('bg-green-darker current');
      $(this).addClass('bg-green-darker current');

      // Toggle product list items based on filter
      var filterVal = $(this).data('label');

      if (filterVal == 'all-products') {
        $('.js-product-list .js-product-card.hidden').removeClass('hidden');
      } else {
        $('.js-product-list .js-product-card').each(function () {
          if (!$(this).hasClass(filterVal)) {
            $(this).addClass('hidden');
          } else {
            $(this).removeClass('hidden');
          }
        });
      }
    });

    // Search filter
    $('#product-filter').on('keyup', function () {
      var value = $(this).val().toLowerCase();
      $('.js-product-list .js-product-card').filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
      });
    });

    // Product label toggle on mobile
    $('.js-toggle-labels').click(function () {
      console.log('clicked button')
      if (!$('.js-labels').hasClass('hidden')) {
        $('.js-labels').addClass('hidden');
      } else {
        $('.js-labels').removeClass('hidden');
        $('.js-labels').addClass('flex');
      }
      // Close labels when click on a label
      $('.js-labels').click(function () {
        $('.js-labels').addClass('hidden');
        $('.js-labels').removeClass('flex');
      });
    });

    // Smooth scroll
    $('.map-link').click(function () {
      var text = $(this).data('country').toLowerCase().replace(' ', '-');
      console.log(text);
      $('html, body').animate({
        scrollTop: $('.' + text).offset().top,
      }, 2000);
    });

    // Accordion
    var acc = document.getElementsByClassName('js-accordion-title');
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function () {
        this.classList.toggle('active');
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    }

    // Tabbed harvest calendar
    $('.js-harvest-calendar .js-mapview-btn').click(function () {
      if ($('.js-mapview-content').hasClass('hidden')) {
        $('.js-mapview-content').removeClass('hidden')
        $('.js-graphview-content').addClass('hidden')
        $(this).addClass('bg-whitesmoke text-gray-700 outline-none')
        $('.js-graphview-btn').removeClass('bg-whitesmoke text-gray-700')
      }
    });

    $('.js-harvest-calendar .js-graphview-btn').click(function () {
      if ($('.js-graphview-content').hasClass('hidden')) {
        $(this).addClass('bg-whitesmoke text-gray-700 outline-none')
        $('.js-mapview-btn').removeClass('bg-whitesmoke text-gray-700 outline-none')
        $('.js-graphview-content').removeClass('hidden')
        $('.js-mapview-content').addClass('hidden')
      }
    });

    // Counter stats
    $(document).ready(function () {
      $('.js-counter').waypoint({
        handler: function () {
          $('.js-count').each(function () {
            const initial = $(this).text()
            const format = formatter(initial)
            $(this).prop('Counter', 0).animate({
              Counter: format.value,
            }, {
              duration: 3000,
              easing: 'swing',
              step: function (now) {
                $(this).text(format.revert(Math.ceil(now)));
              },
            });
          });
        },
        offset: '100%',
      });
    });

    function formatter(str) {
      // const delimeter = '-'
      const char = 'x'
      const template = str.replace(/\d/g, char)
      const value = str.replace(/\D/g, '')

      function revert(val) {
        // need better solution
        const valStr = val.toString()
        let result = ''
        let index = 0
        for (let i = 0; i < template.length; i++) {
          const holder = template[i]
          if (holder === char) {
            result += valStr.slice(index, index + 1)
            index++
          } else {
            result += holder
          }
        }
        return result
      }
      return {
        template: template,
        value: value,
        revert: revert,
      }
    }

    // Toggle mobile nav
    $('.js-hamburger').click(function () {
      $('.mobile-nav').toggleClass('is-active');
    })

    // SVG down icon
    let svgIcon = '<svg class="w-6 h-6 fill-current text-gray-a3a "  viewBox="0 0 20 20"><path d="M9.3 12.95l.7.7L15.66 8l-1.42-1.41L10 10.83 5.76 6.59 4.34 8z"/></svg>'

    // Add icon to mobile navigation parent links
    $('.mobile-nav__item--parent').each(function () {
      $(this).prepend('<span class="mobile-nav__toggle-icon transition duration-300 ease-in-out ">' + svgIcon + '</span>');
    });

    $('.mobile-nav__toggle-icon').click(function () {
      console.log('clicked jquery icon nice');
      $(this).toggleClass('transform -rotate-180')
      if ($(this).parent().find('ul').hasClass('is-active')) {
        $(this).parent().find('ul').removeClass('is-active')
      } else {
        $(this).parent().find('ul').addClass('is-active')
      }
    })

    // Scroll
    jQuery(document).ready(function ($) {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 60) {
          $('.js-header').addClass('scrolld');
        } else {
          $('.js-header').removeClass('scrolld');
        }
      });
    });

    // Simple slideshow
    // https://css-tricks.com/snippets/jquery/simple-auto-playing-slideshow/
    $('.js-slideshow > .js-slideshow-slide:gt(0)').hide();

    setInterval(function () {
      $('.js-slideshow > .js-slideshow-slide:first')
        .fadeOut(1000)
        .next()
        .fadeIn(1000)
        .end()
        .appendTo('.js-slideshow');
    }, 7500);

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js